function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 3.333,
  r: 3.333,
  fill: "#59A315"
});
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 12.667,
  fill: "#FDCE00",
  r: 3.333
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.667,
  cy: 8,
  fill: "#EB0C3B",
  r: 3.333
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.333,
  cy: 8,
  r: 3.333,
  fill: "#0E72ED"
});
function SvgSimpleColorPicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}
export default __webpack_public_path__ + "fonts/simple-color-picker-32d30b97fe686e82221aa5e16d6724fd.svg";
export { SvgSimpleColorPicker as ReactComponent };